import { render, staticRenderFns } from "./TraderInfoWorkTypes.vue?vue&type=template&id=38ea1dfc&"
import script from "./TraderInfoWorkTypes.vue?vue&type=script&lang=ts&"
export * from "./TraderInfoWorkTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports